// @ts-nocheck
import * as React from "react";
import { IconOffset } from "@toolkit/Framework/Types/Icon";

const ChevronRight: React.FC = () => {
    return (
        /* Store Custom Code - Start */
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M8.063 21.308 7 20.244 15.244 12 7 3.756l1.063-1.064L17.371 12l-9.307 9.308Z"
            />
        </svg>
        /* Store Custom Code - End */
    );
};

export const ChevronRightOffset: IconOffset = {
    vertical: 10, // Store Custom Code
    horizontal: 28, // Store Custom Code
};

export default React.memo(ChevronRight);
